import { render, staticRenderFns } from "./RoutersTab.vue?vue&type=template&id=e0058808&scoped=true&"
import script from "./RoutersTab.vue?vue&type=script&lang=js&"
export * from "./RoutersTab.vue?vue&type=script&lang=js&"
import style0 from "./RoutersTab.vue?vue&type=style&index=0&id=e0058808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0058808",
  null
  
)

export default component.exports